








import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component
export default class MsgList extends Vue {
  @Prop() private msgList!: string [];
  @Prop({ type: Boolean, default: false }) private show!: boolean;
}
